export default __webpack_public_path__ + "static/media/duckhunt.d191c00a.gif";